
export default {
  SET_INPUT_STATE(state, newState) {
    state.inputState = {
      ...state.inputState,
      ...newState
    };
  },

  SET_ITEM_INFO(state, itemInfo) {
    state.itemInfo = itemInfo;
  },

  SET_ITEM_VARIANT(state, variants) {
    state.itemInfo = {
      ...state.itemInfo,
      variants
    };
  },

  SET_LOADING(state, isLoading) {
    state.isLoading = isLoading;
  },

  SET_QUANTITY(state, number) {
    state.quantity += number
    localStorage.setItem('oders.quantity', JSON.stringify(state.quantity))
  },

  SET_VARIATION_ID(state, id) {
    state.variationId = id
  }
};
